















import Vue from 'vue'
import { IconSubtitleElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'IconSubtitleEl',
  props: {
    templateItemData: {
      type: Object as () => IconSubtitleElInterface,
      required: true
    }
  },
  computed: {
    style (): string {
      return `background:${this.templateItemData.background}; color: ${this.templateItemData.color};`
    }
  }
})
